import { groupBy, omit, uniq } from 'lodash';

const collectPropValue = (steps, collectedPropName) =>
  uniq(steps.map(step => step[collectedPropName]));

const mergeSteps = (
  stepsGroupedByPropertyValue,
  mergePriority,
  collectedPropName,
) =>
  Object.keys(stepsGroupedByPropertyValue).map(propertyValue => {
    const steps = stepsGroupedByPropertyValue[propertyValue];

    const step = steps.find(step => step[mergePriority]) || steps[0];

    if (collectedPropName) {
      const collectedPropValues = collectPropValue(steps, collectedPropName);
      return { ...step, collectedPropValues };
    }
    return step;
  });

const getMergedByPropertySteps = (
  steps,
  { mergeProp, mergePriority, collectedPropName },
) => {
  const stepsGroupedByPropertyValue = groupBy(Object.values(steps), mergeProp);
  const filteredStepsGroupedByPropertyValue = omit(
    stepsGroupedByPropertyValue,
    ['undefined'],
  );
  return mergeSteps(
    filteredStepsGroupedByPropertyValue,
    mergePriority,
    collectedPropName,
  );
};

export default getMergedByPropertySteps;
